<template lang="pug">
.notice
  .title
    div
      span 通知
      i.ivu-icon.ivu-icon-ios-more(@click='changeType()')
        div.delete-menu(v-show='menuShow' @click='deleteAllMessage()')
          Icon(type="ios-trash-outline")
          span 删除所有消息
    div
      li(v-for='(v,index) in list',@click='fun_go(v);checkReaded(v);query();',style='position:relative;')
        //- i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont(v-if='v.isRead === 1' style='top:-40px;')
        Badge(dot,v-if='v.isRead === 0')
          i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont
        i.iconfont.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont(v-else style='margin-top: 24px;display:block;float:left;')
        div(v-if='v.type==="教师分配实训通知"').type
          div.time {{day(v.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
          div.content-text {{JSON.parse(v.content).notifyTheBoxContent}}
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
        div(v-if='v.type==="老师审核自定义案例"').type
          div.time {{day(v.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
          div.content-text 您提交的案例已经被审核
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`案例名称：<b>${JSON.parse(v.content).caseName} </b>`')
          div.content-text(v-html='`审核结果：<b>${JSON.parse(v.content).auditStatus} </b>`')
          div.content-text(v-html='`审核建议：<b>${JSON.parse(v.content).auditContent} </b>`')
        div(v-if='v.type==="老师评分"').type
          div.time {{day(v.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
          div.content-text 您有新的实训报告可以下载
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text(v-html='`案例名称：<b>${JSON.parse(v.content).caseExperimentName} </b>`')
        div(v-if='v.type==="密码重置提示"').type
          div.time {{day(v.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
          div.content-text 密码重置提示
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
          div.content-text 用户ID : {{v.userId}}
        div(v-if='v.type==="教师延续分配通知"').type
          div.time {{day(v.createdTime).format('YYYY-MM-DD HH:mm:ss')}}
          div.content-text {{JSON.parse(v.content).notifyTheBoxContent}}
          div.content-text
            span 案例:
            b {{v.policyName}}
            span 案例已分配至
            b {{v.policyType}}
            a(style="cursor: pointer" @click='checkReaded(v);query();') 点击查看
</template>
<script>
import dayjs from "dayjs";
import MyBus from "@/utils/main";
export default {
  data() {
    return {
      day: dayjs,
      list: [],
      menuShow: false
    };
  },
  created() {
    this.query();
  },
  methods: {
    fun_go(v) {
      MyBus.$emit("fun_notice");
      // 跳转到审核页面
      switch (v.type) {
        case "教师分配实训通知":
          this.$router.push("/Student/case_list");
          this.$parent.pageIndex = 1;
          this.checkReaded(v);
          this.query();
          break;
        case "老师审核自定义案例":
          this.$router.push("/Student/custom-case");
          this.$parent.pageIndex = 4;
          this.checkReaded(v);
          this.query();
          break;
        case "老师评分":
          this.$router.push("/Student/see_ranking");
          this.$parent.pageIndex = 0;
          this.checkReaded(v);
          this.query();
          break;
        case "教师延续分配通知":
          this.$router.push("/Student/case_list");
          this.$parent.pageIndex = 1;
          this.checkReaded(v);
          this.query();
          break;
        default:
          break;
      }
    },
    query() {
      const data = {
        userId: this.$role.code,
        types: JSON.stringify([
          "教师分配实训通知",
          "老师审核自定义案例",
          "老师评分",
          "教师延续分配通知"
        ])
        // type: "外部通知"
      };
      this.$http.listWithoutNotification(data).then(res => {
        if (res.data.success) {
          this.list = res.data.data.list;
          this.list.forEach(res1 => {
            if (res1.type === "教师延续分配通知") {
              res1.notifyInfoShort = JSON.parse(res1.content).notifyInfoContent.split(" ")[1];
              res1.policyName = res1.notifyInfoShort.split("案例已分配至")[0];
              res1.policyType = res1.notifyInfoShort.split("案例已分配至")[1];
            }
          });
        }
      });
      this.$forceUpdate();
    },
    checkReaded(v) {
      const data = {
        ids: [v.id]
      };
      data.ids = JSON.stringify(data.ids);
      this.$http.updateNotificationRead(data).then(res => {
        console.log(res);
      });
      this.query();
    },
    changeType() {
      this.menuShow = !this.menuShow;
      MyBus.$emit("change_mask");
    },
    deleteAllNotification() {
      this.$http.deleteAllNotification().then(res => {
        if (res.data.success) {
          this.$Message.success("删除成功");
          this.query();
        }
      });
    },
    deleteAllMessage() {
      // this.changeType();
      this.$Modal.confirm({
        title: "确定删除所有消息？",
        onOk: () => {
          this.deleteAllNotification();
        }
      });
    }
  },
  mounted() {
    MyBus.$on("isDelete", e => {
      this.menuShow = e;
    });
  }
};
</script>
<style lang="stylus" scoped>
.notice
  // position absolute
  min-width 854px
  max-width 1126px
  min-height 626px
  background rgba(255, 255, 255, 1)
  border-radius 4px
  left 256px
  right 256px
  margin auto
  text-align left
  margin-top 40px
  .title
    font-size 24px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    // max-height 80vh
    overflow auto
    line-height 30px
    padding 28px 32px 42px 32px
    .ivu-icon-ios-more
      float right
      position relative
      z-index 999
      cursor pointer
      .delete-menu
        position absolute
        right 0
        width 156px
        height 44px
        background rgba(255,255,255,1)
        box-shadow 0px 0px 6px 0px rgba(0,0,0,0.2)
        border-radius 4px
        z-index 999
        cursor pointer
        .ivu-icon-ios-trash-outline
          font-size 20px
          line-height 44px
          text-align initial
        span
          font-size 14px
          font-weight 400
          color rgba(42,46,54,0.8)
          line-height 44px
          margin-left 8px
    .ivu-badge
      position relative
      display block
      float left
      margin-top 24px
      // top -40px
      // bottom 20px
    .iconfont
      color #508FF4
      font-size 24px
      position relative
      // top -40px
    .type
      display inline-block
      margin 24px
      width calc(100% - 80px)
      border-bottom 1px solid #dddddd
      margin-bottom 0
      // cursor pointer
      .time
        font-size 12px
        font-family MicrosoftYaHeiUI
        color rgba(153, 153, 153, 1)
        line-height 15px
        margin-bottom 10px
      .content-text
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(79, 87, 102, 0.8)
        margin-bottom 7px
        line-height 18px
        a
          margin-left 10px
          cursor pointer
</style>
